import React, { useEffect, useState } from 'react';
import { Configure } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

// Components
import PropertyContactsListHits from './PropertyContactsListHits';
import MemberCardRedesign from '@molecules/MemberCardRedesign';
import SearchContainer from '@search/SearchContainer';
import { BodyLarge } from '@styled';

// Functionality
import { SAVED_CONTACTS_RECORD_ID_QUERY } from '@general/graphql/contact.graph';
import { mapSearchMemberToProps } from '@general/transforms/member.transform';

const PropertyContactsList = ({ contacts, onContactRemove }) => {
    const [filters, setFilters] = useState('');

    useEffect(() => {
        let newFilter = '';

        if (contacts.length > 0) {
            newFilter = contacts.map(c => `graphId:"${c}"`).join(' OR ');
        }

        setFilters(newFilter);
    }, [contacts]);

    if (contacts.length === 0) {
        return <BodyLarge>No additional contacts designated</BodyLarge>;
    }

    return (
        <SearchContainer index="members">
            <Configure filters={filters} distinct />
            <PropertyContactsListHits
                query={SAVED_CONTACTS_RECORD_ID_QUERY}
                hitComponent={MemberCardRedesign}
                transformFunc={mapSearchMemberToProps}
                listClasses="row align-items-stretch"
                listItemClasses="col-12 col-lg-6 my-3"
                isLoggedIn
                typePlural="contacts"
                showMailIcon={false}
                showTrashIcon
                onTrashClick={onContactRemove}
            />
        </SearchContainer>
    );
};

PropertyContactsList.propTypes = {
    contacts: PropTypes.arrayOf(PropTypes.string),
    onContactRemove: PropTypes.func,
};

export default PropertyContactsList;
